import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { isEmpty } from 'lodash';
import InfiniteScroll from 'react-infinite-scroll-component';
import SearchBar from '../../../../Components/Utility/FilterAction/SearchBar';
import BtnAdd from '../../../../Components/Utility/FilterAction/BtnAdd';
import BtnSelectAll from '../../../../Components/Utility/FilterAction/BtnSelectAll';
import BtnDelete from '../../../../Components/Utility/FilterAction/BtnDelete';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import * as action from '../store/ColorLibrary.action';
import Loader from '../../../../Components/Utility/Loader/Loader';
import CommonColorWayEdit from '../../../../Components/CommonColorWay/CommonColorWayEdit';
import ColourLibraryGroupCard from '../../../../Components/Card/ColourLibraryGroupCard/ColourLibraryGroupCard';
import { useComponent } from '../../../UserSetting/UsersLibrary/UserRights';
import { Page_Size } from '../../../../Components/helper';
import * as systemMasterAction from '../../../SystemMasters/Store/SystemMasters.action';

function ColorLibraryGroup() {
  const { t } = useTranslation('common');
  const colourReducers = useSelector((reducerstate) => reducerstate);
  const { UserDetails, ColorLibraryDetails } = colourReducers;
  const { userInfo } = UserDetails;
  const { ColourGroupPageWiseList, totalColourGroupCount } = ColorLibraryDetails;
  const dispatch = useDispatch();

  const { createConditionalComponent, CheckActionPermission } = useComponent();
  const ProductTestingData = useSelector((redState) => redState);
  const { Users } = ProductTestingData;
  const { SystemMastersDetails } = useSelector((reduxState) => reduxState);
  const { subBrandAccess } = SystemMastersDetails;
  const { logInRights } = Users;
  const [userRights, setUserRights] = useState({});
  const [uploadColorWayEdit, setUploadColorWayEdit] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [showSearchMobile, setSearchMobile] = useState(false);
  const [isSelectAll, setSelectAll] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [colourDeleteId, setColourDeleteId] = useState(null);
  const [colourLibraryModal, setColourLibraryModal] = useState({ show: false });
  const [selectedIdArray, setSelectedIdArray] = useState([]);
  const [state, setState] = useState({
    colourLibraryGroups: [],
    loading: false,
    searchText: '',
    searchLoaded: false,
    pageIndex: 1,
    pageSize: Page_Size,
    hasMore: false,
  });

  useEffect(() => {
    const fetchSubBrandAccess = async () => {
      await dispatch(systemMasterAction.getSubBrandAccess());
    };
    fetchSubBrandAccess();
  }, [dispatch]);
  useEffect(() => {
    if (logInRights) {
      setUserRights(logInRights);
    }
  }, [logInRights]);

  useEffect(() => {
    if (ColourGroupPageWiseList?.length === totalColourGroupCount) {
      setState((oldState) => ({
        ...oldState,
        hasMore: false,
      }));
    } else {
      setState((oldState) => ({
        ...oldState,
        hasMore: true,
      }));
    }
  }, [totalColourGroupCount, ColourGroupPageWiseList?.length]);

  const DeleteDesignWrapper = createConditionalComponent(userRights, 'libraries', 'colours', 'delete');
  const ColurAddEditAccess = CheckActionPermission(userRights, 'libraries', 'colours', 'addEdit');
  const ColourDeleteAccess = CheckActionPermission(userRights, 'libraries', 'colours', 'delete');

  const handleMobileSearch = (clear) => {
    if (clear) {
      setState((mobstate) => ({
        ...mobstate,
        searchText: '',
        searchLoaded: true,
      }));
    }
    setSearchMobile(!showSearchMobile);
  };

  const handleToggleColorPopupEdit = async (e) => {
    if (e) {
      e.preventDefault();
    }
    setColourLibraryModal({ show: !colourLibraryModal.show });
    await getColourGroupLib({ loggedInUserId: userInfo.userId });
    await dispatch(action.clearReducer());
  };

  useEffect(() => {
    async function fetchApi() {
      if (userInfo?.userId) {
        await dispatch(action.fetchColourGroupbyPgination({ loggedInUserId: userInfo?.userId, pageIndex: state.pageIndex, pageSize: state.pageSize }));
        setState((endfetchstate) => ({
          ...endfetchstate,
          loading: false,
        }));
      }
    }
    setState((endfetchstate) => ({
      ...endfetchstate,
      loading: true,
    }));
    fetchApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (ColourGroupPageWiseList) {
      setState((clstate) => ({
        ...clstate,
        colourLibraryGroups: [...ColourGroupPageWiseList],
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ColourGroupPageWiseList]);

  const getColourGroupLib = async (data) => {
    setState((getclgstate) => ({
      ...getclgstate,
      loading: true,
      colourLibraryGroups: [],
      ...data,
    }));
    const params = {
      loggedInUserId: userInfo.userId,
      pageIndex: data?.pageIndex || 1,
      pageSize: Page_Size,
      isScrolled: false,
    };
    if (data.searchText) {
      params.searchText = data.searchText;
    }
    dispatch(action.fetchColourGroupbyPgination(params));
    setState((fstate) => ({
      ...fstate,
      loading: false,
    }));
  };

  const handleDeleteCard = async (id) => {
    setColourDeleteId(id);
    setShowConfirmationPopup(!showConfirmationPopup);
  };

  const handleSelectAll = () => {
    if (isSelectAll) {
      setSelectedIdArray([]);
    } else {
      const selectedItems = [...selectedIdArray];
      for (const item of state.colourLibraryGroups) {
        const findItems = selectedItems.filter((val) => val === item._id);
        if (isEmpty(findItems)) {
          selectedItems.push(item._id);
        }
      }
      setSelectedIdArray(selectedItems);
    }
    setSelectAll(!isSelectAll);
  };

  const deleteById = async () => {
    setShowConfirmationPopup(!showConfirmationPopup);
    setState((delstate) => ({
      ...delstate,
      loading: true,
    }));
    const params = { loggedInUserId: userInfo.userId };
    if (colourDeleteId) {
      params.groupIds = JSON.stringify([colourDeleteId]);
    } else {
      params.groupIds = JSON.stringify([...selectedIdArray]);
    }
    dispatch(action.deleteColorGroup(params, t));
    setState((delConfstate) => ({
      ...delConfstate,
      loading: false,
    }));
    const getParams = { loggedInUserId: userInfo.userId };
    getColourGroupLib(getParams);
  };

  const onSelectCheckBox = async (_e, id) => {
    let selectedItems = [...selectedIdArray];
    const findItems = selectedItems.filter((item) => item === id);
    if (!isEmpty(findItems)) {
      selectedItems = selectedItems.filter((item) => item !== id);
      setSelectedIdArray([...selectedItems]);
    } else {
      setSelectedIdArray([...selectedItems, id]);
    }
  };

  const handleSearch = async (e) => {
    const targetValue = e.target.value;
    setState((searchstate) => ({
      ...searchstate,
      searchText: targetValue,
      searchLoaded: true,
    }));
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (state.searchLoaded) {
        setState((debstate) => ({
          ...debstate,
          loading: true,
          colourLibraryGroups: [],
        }));
        setSelectedIdArray([]);
        setSelectedId(null);
        setSelectAll(false);
        const params = {
          loggedInUserId: userInfo.userId,
          searchText: state.searchText,
          colourLibraryGroups: [],
          isSelectAll: false,
          selectedIdArray: [],
        };
        await getColourGroupLib(params);
        setState((getstate) => ({
          ...getstate,
          loading: false,
          searchLoaded: false,
        }));
      }
    }, 1000);
    return () => clearTimeout(delayDebounceFn);
  }, [state.searchText]); // eslint-disable-line react-hooks/exhaustive-deps

  const deleteColourType = (id) => {
    setColourDeleteId(id);
    setShowConfirmationPopup(!showConfirmationPopup);
  };

  const toogleColorImageUploderEdit = () => setUploadColorWayEdit(!uploadColorWayEdit);

  const handleNextPagesInScroll = async () => {
    let index = state.pageIndex;
    index += 1;
    const params = {
      pageIndex: index,
      pageSize: state.pageSize,
      searchText: state.searchText,
      loggedInUserId: userInfo.userId,
      isScrolled: true,
      isSelectAll: false,
    };
    setState((searchstate) => ({
      ...searchstate,
      pageIndex: index,
    }));
    setState((fetchstate) => ({
      ...fetchstate,
      loading: true,
    }));
    dispatch(action.fetchColourGroupbyPgination(params));
  };

  const headerBtns = () => {
    return (
      <>
        <Link className="cursor-pointer text-dark text-decoration-none" to="/libraries/colour-group/add">
          <BtnAdd
            // onBtnClick={addColorLibrary}
            addEditAccess={ColurAddEditAccess}
          />
        </Link>

        <DeleteDesignWrapper>
          <BtnDelete multiDelete={() => deleteColourType(null)} isDisabled={isEmpty(selectedIdArray)} />
        </DeleteDesignWrapper>
        <div className="break" />
        {ColurAddEditAccess || ColourDeleteAccess ? (
          <BtnSelectAll handleSelectAll={handleSelectAll} isSelectAll={isSelectAll} isDisabled={isEmpty(state.colourLibraryGroups)} />
        ) : (
          ''
        )}
      </>
    );
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <h4 className="title">{t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.COLOUR_LIBRARY_GROUP.COLOUR_ARTWORK_GROUPS')}</h4>
        </div>
        <div className="search-filter selectall-search-xs">
          <SearchBar
            onSearch={handleSearch}
            value={state.searchText}
            placeholder={t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.COLOUR_LIBRARY_GROUP.SEARCH_COLOUR_ARTWORK_GROUP')}
            showMobileSearch={showSearchMobile}
            handleMobileSearch={handleMobileSearch}
          />
          {headerBtns()}
        </div>
      </div>
      <div className="container-fluid">
        <div className="d-flex justify-content-end my-3">
          <Link
            className={`cursor-pointer text-dark text-decoration-none ${
              window.location.href.includes('/colour-library') ? 'btn-active btn btn-page-filter' : 'btn btn-page-filter'
            }`}
            to="/libraries/colour-library"
          >
            <span className="lib-name">
              {`${t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.COLOUR_LIBRARY_GROUP.COLOUR_ARTWORK')} ${t(
                'COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.COLOUR_LIBRARY_GROUP.LIBRARY',
              )}`}
            </span>
          </Link>
          <Link
            className={`cursor-pointer text-dark text-decoration-none ${
              window.location.href.includes('/colour-groups') ? 'btn-active btn btn-page-filter' : 'btn btn-page-filter'
            }`}
            to="/libraries/colour-groups"
          >
            <span className="lib-name">
              {`${t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.COLOUR_LIBRARY_GROUP.COLOUR_ARTWORK')} ${t(
                'COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.COLOUR_LIBRARY_GROUP.GROUPS',
              )}`}
            </span>
          </Link>
        </div>
        {!state.loading && state.colourLibraryGroups && isEmpty(state.colourLibraryGroups) && (
          <div>
            <div className="w-100 text-center">
              <Container fluid className="py-4">
                <Row>
                  <Col md="12">
                    <p className="">{t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.COLOUR_LIBRARY_GROUP.COLOUR_GROUP')}</p>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        )}
      </div>
      {state.loading && isEmpty(state.colourLibraryGroups) ? (
        <div className="text-center py-4">
          <Loader />
        </div>
      ) : (
        <InfiniteScroll
          dataLength={ColourGroupPageWiseList?.length} // This is important field to render the next data
          hasMore={state.hasMore}
          next={() => handleNextPagesInScroll()}
          loader={state.loading && <Loader />}
          scrollableTarget="scrollableDiv"
        >
          {state.colourLibraryGroups && !isEmpty(state.colourLibraryGroups) && (
            <div className="container-fluid">
              <div className="row">
                {state.colourLibraryGroups.map((item, i) => {
                  return (
                    <React.Fragment key={item?.name || i}>
                      <ColourLibraryGroupCard
                        editeble
                        item={item}
                        index={i}
                        onDelete={handleDeleteCard}
                        onCheck={onSelectCheckBox}
                        selectedIds={selectedIdArray}
                        isImport={false}
                        ColurAddEditAccess={ColurAddEditAccess}
                        ColourDeleteAccess={ColourDeleteAccess}
                        subBrandAccess={subBrandAccess}
                      />
                    </React.Fragment>
                  );
                })}
              </div>
            </div>
          )}
        </InfiniteScroll>
      )}
      {colourLibraryModal.show && (
        <CommonColorWayEdit id={selectedId} onOpen={colourLibraryModal.show} toogle={handleToggleColorPopupEdit} imageUpload={toogleColorImageUploderEdit} />
      )}

      {showConfirmationPopup && (
        <ConfirmationPopup
          onOpen={showConfirmationPopup}
          onConfirm={deleteById}
          loading={state.loading}
          title={t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.COLOUR_LIBRARY_GROUP.DELETE_COLOUR_GROUP')}
          message={t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.COLOUR_LIBRARY_GROUP.DELETE_COLOUR_MESSAGE')}
          toggle={() => setShowConfirmationPopup(!showConfirmationPopup)}
        />
      )}
    </>
  );
}

export default ColorLibraryGroup;
